import * as React from 'react'
import { Icons, Typography } from '@lacedltd/laced-components'
import { useLocale, useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import Carousel from '../../Carousel'
import * as S from './NoResultsGrid.styles'

const NoResultsGrid = () => {
  const { t } = useTranslation()
  const { locale, currency, location } = useLocale()

  return (
    <S.Container>
      <S.CopyContainer>
        <Icons.Search />
        <Typography.Heading as="h3">
          {t('react_components.product.no_results')}
        </Typography.Heading>
        <Typography.Text variant="body">
          {t('react_components.product.discover_other')}
        </Typography.Text>
      </S.CopyContainer>
      <Carousel
        title={t('shared.trending_now')}
        section="trending_products"
        currency={currency}
        locale={locale}
        delivery_location={location.code}
      />
      <Carousel
        title={t('shared.recently_viewed')}
        section="recently_viewed"
        currency={currency}
        locale={locale}
        delivery_location={location.code}
      />
    </S.Container>
  )
}

export default withTranslations(NoResultsGrid)
